// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".highcharts-xaxis-labels[data-v-1e2746a2]{width:100px}.ecl-card[data-v-1e2746a2],.ecl-card-rural[data-v-1e2746a2]{width:95%!important;margin-left:4px;margin-top:4px;margin-bottom:4px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
